import { TextInput } from "dripsy";

export default TextInput;
